import { AppTheme } from "../tokens";

export const lightTheme: AppTheme = {
  mode: "light",
  palette: {
    colorPrimary: "#F26522",
    colorPrimaryDark: "#1a2744",
    colorPrimaryDarker: "#0a0a14",
    colorPrimaryLight: "#F2652240",
    colorPrimaryLighter: "#F2652220",
    colorPrimaryLightest: "#FFF3ED",
    colorGray: "#ADADAD",
    colorGray2: "#e2e8f0",
    colorGrayDark: "#626262",
    colorGrayDarker: "#333333",
    colorGrayLight: "#B9B9B967",
    colorError: "#ef5350",
    colorWarning: "#ff9800",
    colorSuccess: "#22c55e",
    colorBlack: "#0a0a14",
    colorBlack2: "#121111",
    colorWhite: "#FFFFFF",
    colorFont: "#1e3a5f",
    colorBlue: "#38bdf8",
    fontSize: "1rem",
    formLabelSize: "0.9rem",
    formErrorSize: "0.8rem",
    title: "1.2rem",
    colorPrimaryGradientFrom: "#0a0a14",
    colorPrimaryGradientTo: "#1a2744",
    colorPrimaryGradientFromLight: "rgba(255,255,255,0.08)",
    colorPrimaryGradientToLight: "rgba(255,255,255,0.04)",
    colorSearchInputOutline: "#F2652219",
    colorInputOutline: "#F2652280",
    colorSearchBarGradient: "rgb(242, 101, 34)",
    colorSelectedProject: "#F2652219",
    colorProjectCard: "#F2652265",
    colorProjectCardLight: "#F265220D",
    sizeHeaderHeight: "0.55rem",
    // Dark-modal helper colours (hint text, disabled primary button).
    colorTextHint: "rgba(255,255,255,0.6)",
    colorDisabledBg: "rgba(255,255,255,0.08)",
    colorDisabledBorder: "rgba(255,255,255,0.12)",
    colorDisabledText: "rgba(255,255,255,0.35)",
    colorWhiteFaint: "rgba(255,255,255,0.30)",
    colorWhiteMuted: "rgba(255,255,255,0.65)",
    colorWhiteDisabled: "rgba(255,255,255,0.25)",
    colorWhiteSubtle: "rgba(255,255,255,0.08)",
    colorDropdownOptionBg: "#111a2e",
    colorModalSurfaceElevated: "rgba(15,22,40,0.98)",
    colorAccentSoft: "rgba(242,101,34,0.15)",
    colorWhiteStrong: "rgba(255,255,255,0.85)",
    colorMenuItemHoverBg: "#2a3a5f",
    // Context filter bar on the dark app: translucent surface, hairline border, blue filters button.
    colorBarSurface: "rgba(255,255,255,0.08)",
    colorBarBorder: "rgba(255,255,255,0.14)",
    colorBarShadow: "0 0.25rem 1rem rgba(0,0,0,0.35)",
    colorBarFilterButtonBg: "rgba(56,189,248,0.18)",
    colorBarFilterButtonIcon: "#38bdf8",
  },
  antd: {
    token: {
      colorPrimary: "#F26522",
      borderRadius: 4,
      fontFamily: "'Inter', -apple-system, sans-serif",
    },
    components: {
      Tabs: {
        itemColor: 'rgba(255, 255, 255, 0.55)',
        itemHoverColor: 'rgba(255, 255, 255, 0.85)',
        itemSelectedColor: '#F26522',
        inkBarColor: '#F26522',
        cardBg: 'transparent',
        titleFontSize: 13,
      },
    },
  },
};
